import createStore from 'redux-zero';
import { applyMiddleware } from 'redux-zero/middleware';

const allowGet = () => sessionStorage.getItem('ttl') && parseInt(sessionStorage.getItem('ttl')) > Date.now();
const allowSet = () => !sessionStorage.getItem('ttl') || parseInt(sessionStorage.getItem('ttl')) < Date.now();
const getData = () => allowGet() ? {
	user: JSON.parse(sessionStorage.getItem('user')),
	agree: JSON.parse(sessionStorage.getItem('agree')),
	isAdmin: JSON.parse(sessionStorage.getItem('isAdmin'))
} : {};
const setData = data => {
	for (let k in data) {
		sessionStorage.setItem(k, JSON.stringify(data[k]));
	}
	sessionStorage.setItem('uuid', data.user.uuid);
	sessionStorage.setItem('ttl', (Date.now() + 3598 * 1000).toString());
};

const mapStateToStorage = async store => {
	const state = store.getState();
	if (allowSet()) {
		if (state.user && state.agree) {
			setData({
				user: state.user,
				agree: state.agree,
				isAdmin: state.isAdmin
			});
		}
	}
};

const persistMiddleware = store => (next, args) => action => {
	const r = next(action);
	if (r && typeof r.then === 'function') {
		return next(action).then((d) => mapStateToStorage(store).then(() => Promise.resolve(d)));
	}
	return mapStateToStorage(store).then(() => Promise.resolve(r));
};


const initialState = {
	user: null,
	agree: false,
	isAdmin: false,
	entries: [],
	settings: false,
	filters: null,
	cardUsers: false,
	...(getData())
};

const middlewares = applyMiddleware(persistMiddleware);
const storage = createStore(initialState, middlewares);

export default storage;



// WEBPACK FOOTER //
// ./store.js